/*
rule
money: 金额
zpNum: 正整数 Z+，Zplus
zNum: 整数
znNum: 负整数
*/

import { moneyRegexp, zpNumRegexp, pIntRegexp } from "./regexps";
const fMergeDefault = otherObj => {
  const defaultOptionObj = {
    message: "请正确填写",
    trigger: "blur"
  };
  return { ...defaultOptionObj, ...otherObj };
};

const money = (options?: Object, message?: String, cb?: Function) => {
  return (
    options ||
    fMergeDefault({
      message,
      pattern: moneyRegexp
    })
  );
};
const numZp = (options?: Object, message?: String, cb?: Function) => {
  return (
    options ||
    fMergeDefault({
      message,
      pattern: zpNumRegexp
    })
  );
};
const numPInt = (options?: Object, message?: String, cb?: Function) => {
  return (
    options ||
    fMergeDefault({
      message,
      pattern: pIntRegexp
    })
  );
};
// methods
export { money, numZp, numPInt };
